<span class="text-danger">
    {{ label() }} must be at least {{ min() }}.
  </span>